import React from 'react';
import Layout from '../components/Layout';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Error page
 */
export default function() {
  const { t } = useTranslation('translation');
  return (
    <Layout>
      <Typography variant="body1" color="error">
        {t('pageUnknown')}
      </Typography>
    </Layout>
  );
}
